export default __webpack_public_path__ + "static/media/28.fcbd0234.png";